<div class="wrapper">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <div class="nav">
    <ul>
      <div *ngFor="let folder of folders">
        <li>
          <a
            routerLink="/mobileDisplay"
            routerLinkActive="active"
            (click)="setFolder(folder)"
            >{{ folder.title }}</a
          >
        </li>
      </div>
      <li>
        <a routerLink="/bio" routerLinkActive="active">Bio</a>
      </li>
      <li>
        <a routerLink="/contact" routerLinkActive="active">Contact</a>
      </li>
    </ul>
  </div>
</div>
